import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AcknowledementConstants } from '../acknowledement-constants';

@Injectable({
  providedIn: 'root'
})
export class AcknowledgementInteractionService {

  closeAndResetAcknowledgementSlider$ = new BehaviorSubject<boolean>(false);
  acknowledgementConfirmationCompleted = new Subject<boolean>();
  acknowledgementAdded = new Subject<boolean>();

  constructor(private confirmationService: ConfirmationService) {}

  openConfirmationDialog = () => {
    this.confirmationService.confirm({
      message: AcknowledementConstants.Acknowledgement_Confirmation_Text,
      header: AcknowledementConstants.Acknowledgement_Slider_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetAcknowledgementSlider$.next(true);
      },
    });
  };

  public OnAcknowledgementConfirmationCompleted(): Observable<boolean> {
    return this.acknowledgementConfirmationCompleted.asObservable();
  }
  public OnAcknowledgementAdded(): Observable<boolean> {
    return this.acknowledgementAdded.asObservable();
  }


}
